import { render } from "./MonitoringCompletedFlowsPage.vue?vue&type=template&id=6abf86f4&scoped=true"
import script from "./MonitoringCompletedFlowsPage.vue?vue&type=script&lang=js"
export * from "./MonitoringCompletedFlowsPage.vue?vue&type=script&lang=js"

import "./MonitoringCompletedFlowsPage.vue?vue&type=style&index=0&id=6abf86f4&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abf86f4"]])

export default __exports__